import React, { useState, useEffect } from "react"
import { useStore } from "../teafuljs/store"
import { getTranslation } from "../scripts/getTranslation"
import SEO from "../components/seo"
import SphereViewBlock from "../components/SphereViewBlock"
import SphereViewData from '../data/SphereViewData.json'
import SphereViewIntro from "../components/SphereViewIntro"
import { makeStyles } from "@material-ui/core/styles"
import SphereView52Passages from "../components/SphereView52Passages"


const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: 100,
  },
  title: {
    width: "100%",
    maxWidth: 800,
    textAlign: "center",
  },
  imageContainer: {
    width: "100%",
    maxWidth: 300,
    textAlign: "center",
    margin: "10px auto",
  },
  imgCaption: {
    width: "100%",
    color: "grey",
    fontSize: "70%",
    margin: "-20px 0 0 0",
    textAlign: "center",
  },
  sloganContainer: {
    width: "100%",
    maxWidth: 800,
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    margin: "20px auto",
    paddingBottom: 20,
    borderBottom: `1px solid ${theme.palette.primary.main}`,
  },
  button: {
    height: 35,
    width: 160,
  },
  paragraph: {
    whiteSpace: "pre-line",
  },
}))

export default function (props) {
  const translations = useStore.translations()[0]
  const language = useStore.language()[0]
  const classes = useStyles()
  const [selected, setSelected] = useState(
    "INT"
  )
  const [clicked, setClicked] = useState(false)
  const [activeStep, setActiveStep] = useState(8)

  const maxSteps = SphereViewData.length

  const handleNext = () => {
    setActiveStep(prevActiveStep => {
      if (prevActiveStep === maxSteps -1) {
        setSelected("INT")
        return 8
      } else if (prevActiveStep === maxSteps) {
        setSelected(SphereViewData[0].id)
        return 0
      } else {
        setSelected(SphereViewData[prevActiveStep + 1].id)
        return prevActiveStep + 1
      }
    })
  }

  // Automatically change the active step every 3 seconds
  useEffect(() => {
    // if (!clicked) {
    //   const interval = setInterval(() => {
    //     // Increment the active step
    //     handleNext()

    //     // Reset the active step to 0 if it exceeds the maximum step count
    //     if (activeStep >= maxSteps) {
    //       setActiveStep(0)
    //     }
    //   }, 4000) // 4000 milliseconds = 4 seconds

    //   // Clear the interval when the component unmounts
    //   return () => clearInterval(interval)
    // }
  }, [activeStep])

  return (
    <div className={classes.root}>
      <SEO title="SphereView" />
      <div>
        <h1 className={classes.title}>
          {getTranslation(translations, language, "UI", "layers_sphereview")}
        </h1>
        <p>
          {getTranslation(translations, language, "UI", "sphereview_intro")}
        </p>
        <SphereViewBlock
          selected={selected}
          setSelected={setSelected}
          setClicked={setClicked}
        />
        <h1>
          {getTranslation(translations, language, "UI", "further_discovery")}
        </h1>
        <div>
          {/* <h1 className={classes.title}>
            {getTranslation(translations, language, "UI", selected)}
          </h1> */}
          <p className={classes.paragraph}>
            {getTranslation(
              translations,
              language,
              "KeyPassages",
              `sphereview_intro_${selected}`
            )}
          </p>
        </div>
        {selected !== "INT" ? (
          <SphereView52Passages sphereId={selected} location={props.location} />
        ) : (
          <SphereViewIntro />
        )}
      </div>
    </div>
  )
}